var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 24,
    viewBox: "0 0 4 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20488 18.24L0.276875 1.216C0.276875 1.04533 0.362208 0.959999 0.532875 0.959999H3.47688C3.64754 0.959999 3.73288 1.04533 3.73288 1.216L2.80488 18.24C2.80488 18.4107 2.71954 18.496 2.54888 18.496H1.46088C1.29021 18.496 1.20488 18.4107 1.20488 18.24ZM0.628875 20.768H3.34888C3.51954 20.768 3.60488 20.8533 3.60488 21.024V23.744C3.60488 23.9147 3.51954 24 3.34888 24H0.628875C0.458209 24 0.372875 23.9147 0.372875 23.744V21.024C0.372875 20.8533 0.458209 20.768 0.628875 20.768Z",
    fill: "#F7E1DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.517de33d3d412db9d15c112518039bde.svg";
export { ForwardRef as ReactComponent };